export default class TwilioClientLogger {
  constructor () {
    return new Proxy(this, {
      get (target, prop) {
        return function twilioClientLoggerGetProxy () {
          const args = [
            '[TwilioClient]',
            ...arguments
          ]
          console[prop].apply(console, args)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/rep-call/twilio-softphone/twilio-client-logger.js